export const Path = 'https://amplify-pricewatch-dev-133013-deployment.s3.us-east-2.amazonaws.com/uploads/';
export const setting_table_id='da461b02-500b-4865-b784-49c2d80ceb25';
export const admin_table_id='efc70449-b0c4-4454-81b1-801fe0685531';
export const bucketName='amplify-pricewatch-dev-133013-deployment';
export const dirName='uploads';
export const region='us-east-2';
export const accessKeyId='AKIATMBOXAAHNQPXBBZ6';
export const secretAccessKey= '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';